<template>
    <a :href="urlArticle"
       @click="handleClick"
       class="content-item content-item-article"
       :class="classes"
       :id="contentItem.contentItemId">
        <span :style="stylesArticle" class="status-badge-small mr-1"></span>
        <span class="ellipsis-nowrap">{{contentItem.title}}</span>
    </a>
</template>
<script>
import widgetContentItemRow from "@/mixins/general/widget-content-item-row";

export default {
    name: 'WidgetArticleRow',
    methods: {
        handleClick(event) {
            if (this.contentItem.id === this.articleId || !this.contentItem.availableForUser) {
                event.preventDefault();
            }
        }
    },
    computed: {
        stylesArticle() {
            return {
                'background-color': `#${this.contentItem.currentStatusColor}`,
                ...this.defaultStyles
            };
        },
        classes() {
            return {
                'not-available-for-user': !this.contentItem.availableForUser,
                active: this.contentItem.id === this.articleId,
                translucent: this.contentItem.translucent
            }
        },
        urlArticle: vm => vm.contentItem.availableForUser ? `/project/${vm.projectId}/edit/${vm.contentItem.id}` : ''
    },
    mixins: [widgetContentItemRow],
}
</script>
